import React from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"

const SearchBox = ({ handleInputChange, ...rest }) => {
  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return <StyledField type="search" onChange={onChange} {...rest} />
}

SearchBox.propTypes = {
  handleInputChange: PropTypes.func.isRequired
}

SearchBox.defaultProps = {
  handleInputChange: undefined
}

export default SearchBox
